export default "__VITE_ASSET__1bab23af__"